import React, { useState } from "react";
import "./contact.css";
import logo from "../assets/logo.jpg";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // you can add form send logic here (Google Sheet / API)
    setSubmitted(true);
  };

  return (
    <div className="contact-root">
      <div className="contact-card">
        <div className="contact-left">
          {/* Replace this path if you want a different image.
              Using the uploaded file path as requested: */}
         <img src={logo} alt="HilalUp bottle" className="contact-img" />

          <div className="contact-details">
            <p className="contact-line">
              📧 <a href="mailto:hilalupofficial@gmail.com">hilalupofficial@gmail.com</a>
            </p>
            <p className="contact-line">
              📞 <a href="tel:+919329766366">+91 9329766366</a>
            </p>
          </div>

          <div className="hours">
            <p><strong>Customer Support</strong></p>
            <p>Mon - Sat: 9:00 AM - 6:00 PM</p>
          </div>
        </div>

        <div className="contact-right">
          <h1 className="contact-title">Contact Us</h1>

          {!submitted ? (
            <form onSubmit={handleSubmit} className="contact-form">
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />

              <input
                type="email"
                placeholder="Your Email"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                required
              />

              <textarea
                placeholder="Your Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>

              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          ) : (
            <div className="thankyou-box">
              <h2>🎉 Thank You!</h2>
              <p>We'll get back to you shortly at <strong>{emailInput}</strong> or on <strong>{/* show phone as link fallback */}<a href="tel:+919329766366">+91 9329766366</a></strong>.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
